module.exports = __webpack_public_path__ + "static/media/EFLogoSm.cfd2cdd4.png";


/*****************
 ** WEBPACK FOOTER
 ** ./src/EFLogoSm.png
 ** module id = 744
 ** module chunks = 0
 **/